import React, { memo } from 'react';
import PropTypes from 'prop-types';

import { compose } from 'redux';
import { connect } from 'react-redux';

import { useInjectReducer } from 'utils/injectReducer';
import { useInjectSaga } from 'utils/injectSaga';

import modifierGroupsDetailsSaga from './sagas';
import reducer from './reducer';

export function ModifierGroupDetails({ children }) {
  useInjectSaga({ key: 'modifierGroupDetails', saga: modifierGroupsDetailsSaga });
  useInjectReducer({ key: 'modifierGroupDetails', reducer });

  return React.Children.only(children);
}

ModifierGroupDetails.propTypes = {
  children: PropTypes.element,
};

const withConnect = connect();

export { default as withModifierGroupDetails } from './withModifierGroupDetails';
export default compose(withConnect, memo)(ModifierGroupDetails);
